module.exports = __webpack_public_path__ + "static/media/2.583175e5.jpg";